<template>
  <div class="px-3 py-2" style="background-color: #8b41e5; height:100vh">
    <b-row>
      <b-col cols="8"
             style="
         height: 80vh;
         margin-left: 15px;
         margin-right: 15px;"
      >
      <side-main
        :session="session"
        :profile="profile"
        @add-data-click="handleAddDataButtonClick"
      />
      </b-col>
      <b-col>
        <side-right
            :session="session"
            :profile="profile"
        />
      </b-col>
    </b-row>
    <b-row style="margin-top: 10px; color:#EBC8A9FF">
      <b-col>
        <h3>{{ sessionTitle }}</h3>
        <h6> {{ sessionTopic }}</h6>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SideMain from "./sideMain";
import SideRight from "./sideRight";
export default {
  name: "Sessions_Sidebar_Session_Body",
  components: {
    SideMain,
    SideRight
  },
  props: {
    session: {
      type: Object,
      default: () => {
        return {}
      }
    },
    profile: {
      type: Object,
      default: () => {
        return {}
      }
    },
    theme: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  mounted() {},
  computed: {
    ...mapGetters({

    })
  },
  methods: {
    handleAddDataButtonClick() {
      this.$emit('add-data-click', this.session);
    }
  },
  data() {
    return {
      sessionTitle: this.session && this.session.session &&
      this.session.session.title ? this.session.session .title : 'Title Error',
      sessionTopic: this.session && this.session.session  &&
      this.session.session.topic ? this.session.session.topic : '',
      mainPropsLogo: { blank: false, blankColor: '#777', class: 'm1' }
    };
  }
};
</script>

<style lang="scss" scoped>
.upload-btn {
  cursor: pointer;
  background-color: #fff;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  max-width: 220px;
  height: 50px;
  border: none;
  letter-spacing: 0.05em;
  align-items: center;
  color: var(--theme-color);
  margin-left: 16px;
  border-radius: 4px;
  transition: all 0.2s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;
  .content {
    display: flex;
    #blogger-publishing-video {
      width: 0;
    }
    #guide-publishing-image {
      width: 0;
    }
    .ico {
      margin-right: 3px;
      img {
        cursor: pointer;
        position: relative;
        top: 50%;
        right: 4px;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
        height: 24px;
        width: 24px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        background: rgba(85, 126, 251, 0.1);
        border-radius: 8px;
      }
      svg {
        height: 30px;
      }
    }
    .watch-video {
      margin-top: 5px;
    }
    .btn-content {
      margin-top: 2px;
      font-family: Nunito;
      font-style: normal;
      font-size: 16px;
      line-height: 22px;
      color: var(--theme-color);
    }
  }
}
.upload-btn:focus {
  outline: none;
  box-shadow: none;
}
</style>
